import Config from 'common/config';
import { getCookie, setCookie } from 'cookies-next';

const defaultUrl = Config.apiEndpoint + '/api/employee';

export class PrefixUrl {
  static readonly key = 'prefixUrl';
  static get() {
    if (!defaultUrl.includes('staging')) {
      return defaultUrl;
    }
    const url = getCookie(PrefixUrl.key);
    if (url) {
      return url;
    }

    return defaultUrl;
  }
  static set(url: string = defaultUrl) {
    if (!defaultUrl.includes('staging')) return;
    if (url) {
      setCookie(PrefixUrl.key, url);
    }
  }
}
